module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-9.bc8f8d7e.svg";